import React from 'react';

const GlobalNotificationContext = React.createContext({});

export const GlobalNotificationProvider = GlobalNotificationContext.Provider;
export const GlobalNotificationConsumer = GlobalNotificationContext.Consumer;
export default GlobalNotificationContext;
